import styled from "styled-components";
import { Button } from "primereact/button";

export const Background = styled.div`
  --fs-hero: clamp(2.3rem, 4.1vw, 3.9rem);
  --fs-body: clamp(1.02rem, 1.15vw, 1.16rem);
  --fs-chip: clamp(0.86rem, 0.82vw, 0.94rem);
  --fs-brand: clamp(1.2rem, 1.15vw, 1.4rem);
  --fs-title: clamp(1.9rem, 2.2vw, 2.3rem);
  --fs-subtitle: clamp(1.08rem, 1.02vw, 1.2rem);
  --fs-button: clamp(1.04rem, 0.96vw, 1.14rem);
  --fs-footer: clamp(0.96rem, 0.88vw, 1.05rem);
  --fs-loading: clamp(0.95rem, 0.85vw, 1rem);

  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: clamp(1rem, 2vw, 2.25rem);
  min-height: 100vh;
  background:
    radial-gradient(circle at 10% 20%, rgba(255, 255, 255, 0.12) 0%, transparent 35%),
    radial-gradient(circle at 80% 80%, rgba(0, 0, 0, 0.16) 0%, transparent 45%),
    linear-gradient(135deg, #1f2937 0%, #111827 45%, #0f172a 100%);
  color: #f8fafc;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
      linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px),
      linear-gradient(0deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px);
    background-size: 48px 48px;
    opacity: 0.25;
    pointer-events: none;
  }

  @media (max-width: 1100px) {
    flex-direction: column;
    justify-content: center;
    padding: 1.25rem;
  }
`;

export const HeroSection = styled.section`
  position: relative;
  z-index: 1;
  flex: 1 1 520px;
  max-width: 620px;
  padding: 3.5rem clamp(1.8rem, 4.2vw, 5rem);
  display: flex;
  flex-direction: column;
  justify-content: center;

  h1 {
    margin: 0;
    font-size: var(--fs-hero);
    line-height: 1.08;
    letter-spacing: -0.02em;
    max-width: 12ch;
  }

  p {
    margin-top: 1rem;
    max-width: 42ch;
    color: rgba(248, 250, 252, 0.84);
    font-size: var(--fs-body);
    line-height: 1.6;
  }

  @media (max-width: 1100px) {
    text-align: center;
    align-items: center;
    padding: 1.25rem 0.5rem 0.8rem;
  }
`;

export const HeroStats = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: 1.75rem;
  flex-wrap: wrap;
  justify-content: center;
  span {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 999px;
    padding: 0.45rem 0.9rem;
    font-size: var(--fs-chip);
    color: rgba(248, 250, 252, 0.96);
  }
`;

export const AuthSection = styled.section`
  position: relative;
  z-index: 1;
  flex: 1 1 520px;
  max-width: 700px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem clamp(1rem, 2.2vw, 2.6rem);

  @media (max-width: 1100px) {
    padding: 0.25rem 0;
  }
`;

export const Card = styled.div`
  width: min(620px, 96%);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  color: #0f172a;
  border-radius: 24px;
  padding: clamp(2rem, 2.8vw, 2.9rem);
  box-shadow: 0 18px 42px rgba(2, 8, 23, 0.24);
  border: 1px solid #e2e8f0;

  @media (max-width: 1100px) {
    width: min(600px, 100%);
  }
`;

export const Brand = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 1.1rem;

  img {
    width: 78px;
    height: 78px;
    border-radius: 18px;
    object-fit: cover;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.18);
  }

  strong {
    font-size: var(--fs-brand);
    color: #334155;
    letter-spacing: -0.01em;
  }
`;

export const Title = styled.h2`
  margin: 0;
  font-size: var(--fs-title);
  letter-spacing: -0.02em;
  line-height: 1.2;
  text-align: center;
`;

export const SubTitle = styled.p`
  margin: 0.65rem 0 1.5rem;
  color: #475569;
  line-height: 1.5;
  font-size: var(--fs-subtitle);
  text-align: center;
`;

export const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 220px;
  color: #334155;

  span {
    margin-top: 0.5rem;
    font-size: var(--fs-loading);
  }
`;

export const Footer = styled.div`
  margin-top: 1.15rem;
  font-size: var(--fs-footer);
  text-align: center;

  span {
    color: #64748b;
  }

  a {
    color: #2563eb;
    font-weight: bold;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const OAuthButton = styled(Button)`
  background-color: #ffffff;
  color: #0f172a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  border-radius: 12px;
  margin: 0;
  border: 1px solid #cbd5e1;
  padding: 1.1rem 1.25rem;
  font-size: var(--fs-button);
  width: 100%;
  height: 62px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  &:enabled:hover {
    background-color: #ffffff;
    border-color: #bfdbfe;
    box-shadow: 0 8px 22px rgba(37, 99, 235, 0.16);
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  .p-button-label {
    color: #0f172a;
    font-weight: 700;
  }

  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
`;
